import { Button, Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { auth } from "../../../firebase";
import axios from "axios";
import { toast } from "react-hot-toast";

const NewPassword = () => {
  const [form] = Form.useForm();
  const [user, loading] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);
  const [isWait, setIsWait] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const userUid = urlParams.get("uid");

  let str = userUid;
  let result = str?.split(",");
  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
    if (!userUid || !str) {
      navigate("/");
    }
  }, [user, loading]);

  const navigate = useNavigate();
  const onFinish = async (values) => {
    setIsWait(true);
    const { password, confirmPassword } = values;

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    const userData = {
      uid: result[0],
      companyName: result[1],
      password: password,
    };
    try {
      const response = await axios.post(
        "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/create-password",
        userData
      );

      toast.success("Password created successfully");
      navigate("/");
      setIsWait(false);
    } catch (error) {
      console.error("Error creating user:", error);
      toast.error("Request failed!");
      setIsWait(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWait(false);
  };

  return (
    <div>
      {isLoading ? (
        <PropagateLoader color="#006eb7" size={5} className="loadingSpinner" />
      ) : (
        <Row>
          <Col xs={24} md={10} lg={10}>
            <div className="leftSide">
              <h1 className="companyTitle">SayEagle</h1>
              <h3 className="userLoginType">Property Manager</h3>
            </div>
          </Col>
          <Col xs={24} md={14} lg={14}>
            <div className="rightSide">
              <h3 className="titlePage">New Password</h3>

              <Form
                form={form}
                name="basic"
                initialValues={{
                  remember: true,
                  totalUnits: {
                    number: 0,
                  },
                }}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{
                  maxWidth: 500,
                  width: "100%",
                }}
              >
                <Form.Item
                  label="New Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                {errorMessage && (
                  <div style={{ color: "red" }}>{errorMessage}</div>
                )}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isWait}
                  >
                    {isWait ? "please wait..." : "Activate"}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default NewPassword;
